module.exports = __webpack_public_path__ + "663027c27b6ad5fb45c883fdb9fec1f9.svg";